import { useEffect } from 'react';

import { graphql, useStaticQuery } from 'gatsby';

import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { BLOCKS } from '@contentful/rich-text-types';

import Button from '../../atoms/button/button';
import './choiseModal.scss';
import { getAssetUrl } from '@/utils/contentFullAsset';

interface ErrorModalInterface {
  closeModal: () => void;
  isMobile?: boolean;
  rightButtonEvent?: () => void;
  rightButtonCopy?: string;
  leftButtonEvent?: () => void;
  leftButtonCopy?: string;
  title?: string;
  subtitle?: any;
  extraEvent?: () => void;
  extraEventCopy?: string;
  imageNew?: any;
}

const ChoiseModal = (props: ErrorModalInterface) => {
  const data = useStaticQuery(graphql`
    query GET_MODAL_CHOISE_DATA {
      allContentfulTemplate(filter: { titulo: { eq: "Modal portal > Estás seguro de cancelar" } }) {
        nodes {
          imagen {
            title
            file {
              url
            }
            svg {
                publicURL
            }
          }
          nombre
          referencias {
            ... on ContentfulTemplate {
              copyBoton
              redireccion
            }
          }
        }
      }
    }
  `);

  const contentData = data.allContentfulTemplate.nodes[0];
  const { imagen, nombre, referencias } = contentData ?? {};

  useEffect(() => {
    document.documentElement.style.overflowY = 'hidden';
    return () => {
      document.documentElement.style.overflowY = 'scroll';
    };
  }, []);

  const setModalClose = () => {
    props.closeModal();
  };

  const setValueClose = () => {
    setModalClose();
  };

  const setOptions = (className: string) => {
    return {
      renderNode: {
        [BLOCKS.PARAGRAPH]: (_node: any, children: any) => <p className={className}>{children}</p>,
      },
    };
  };

  return (
    <div className="m-choise-modal">
      <div className="m-choise-modal__content" onClick={() => {}}>
        <div className="m-choise-modal__exit">
          <i className="icon icon-close m-choise-modal__exit-icon" onClick={setModalClose} />
        </div>
        <div className="m-choise-modal__container">
          {(contentData?.imagen || props.imageNew) && (
            <img
              className="m-choise-modal__container-icon"
              src={props.imageNew ? props.imageNew.url : getAssetUrl(imagen[0])}
              alt={props.imageNew ? props.imageNew.title : imagen[0].title}
              title={props.imageNew ? props.imageNew.title : imagen[0].title}
            />
          )}
          {(nombre || props.title) && (
            <h3 className="m-choise-modal__container-title">
              {props.title ? props.title : nombre}
            </h3>
          )}
          {props.subtitle &&
            (props.subtitle.raw ? (
              documentToReactComponents(
                JSON.parse(props.subtitle.raw),
                setOptions('m-choise-modal__container-description'),
              )
            ) : (
              <p className="m-choise-modal__container-description">{props.subtitle}</p>
            ))}
          <div className="m-choise-modal__container-buttons">
            <Button
              type="button"
              classname="m-choise-modal__container-button --left primary"
              text={
                props.leftButtonCopy
                  ? props.leftButtonCopy
                  : referencias?.[0]?.copyBoton || 'cancelar'
              }
              isDisabled={false}
              onClickAction={props.leftButtonEvent ? props.leftButtonEvent : setValueClose}
            />
            <Button
              type="button"
              classname="m-choise-modal__container-button secondary"
              text={
                props.rightButtonCopy
                  ? props.rightButtonCopy
                  : referencias?.[0]?.copyBoton || 'Aceptar'
              }
              isDisabled={false}
              onClickAction={props.rightButtonEvent ? props.rightButtonEvent : setValueClose}
            />
          </div>
          {props.extraEvent && props.extraEventCopy && (
            <>
              <div className="m-choise-modal__container-separator" />
              <p className="m-choise-modal__container-extra-event" onClick={props.extraEvent}>
                {props.extraEventCopy}
              </p>
            </>
          )}
        </div>
      </div>
      <div className="m-choise-modal__bkg" onClick={setModalClose} />
    </div>
  );
};

export default ChoiseModal;
